import React, { useState } from 'react'
import { Navigate, useParams ,useNavigate, useAsyncError} from 'react-router-dom'
import { jwtDecode } from 'jwt-decode';
import axios from 'axios'

const Paybuyer = () => {
    const {token} = useParams();
    const decodedToken = jwtDecode(token);
    const [msg,setMsg] = useState('Tombol belum di klick')
    const [loading,setLoading] = useState(false)
    console.log(decodedToken)

    const handleSubmit = async() => {
      setLoading(true);
      try {
        const response = await axios.patch(`${process.env.REACT_APP_URL_BACKEND}/auth/paymentbuyer`,{
          id:decodedToken.id,
          beridentitas:decodedToken.beridentitas,
          amount:decodedToken.amount,
          emailSeller:decodedToken.emailSeller,
          emailBuyer:decodedToken.emailBuyer,
          emailAdmin:decodedToken.emailAdmin,
          img:decodedToken.img
        })
        setLoading(false)
        setMsg(response.data.msg)
      } catch (error) {
        setLoading(false)
        setMsg(error.response.data.msg)
        console.error(error)
      }
    }

  return (
    <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      height: '100vh', // Ketinggian penuh layar
      width: '100%', // Lebar penuh layar (opsional jika otomatis)
    }}
  >
    <p style={{ color: 'black' }}>{msg}</p>
    <div className="button-agree">
      <div className="modal-change">
        <button onClick={handleSubmit} disabled={loading}>{loading ? <div className='spinner'></div> : 'Kirim Pembayaran'}</button>
      </div>
    </div>
  </div>
  
  )
}

export default Paybuyer